const baseURL = process.env.REACT_APP_GATEWAY_URL;
const idpURL = process.env.REACT_APP_IDP_URL;
const callBackURL = process.env.REACT_APP_LDS_IDP_CALL_BACK_URL;
const logoutURL = process.env.REACT_APP_LDS_POST_LOGOUT_REDIRECT_URI;

export { baseURL, idpURL, callBackURL, logoutURL };